// GeneralViews
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue';
import Widgets from 'src/components/Dashboard/Views/Dashboard/Widgets.vue';

// Annuaire application pages components
import People from 'src/components/ApplicationViews/People.vue';
import PersonDetails from 'src/components/ApplicationViews/PersonDetails.vue';
import Institutions from 'src/components/ApplicationViews/Institutions.vue';
import InstitutionDetails from 'src/components/ApplicationViews/InstitutionDetails.vue';
import Committees from 'src/components/ApplicationViews/Committees.vue';
import CommitteeDetails from 'src/components/ApplicationViews/CommitteeDetails.vue';
import Profiles from 'src/components/ApplicationViews/Profiles.vue';
import AddressTypes from 'src/components/ApplicationViews/AddressTypes.vue';
import Cantons from 'src/components/ApplicationViews/Cantons.vue';
import Countries from 'src/components/ApplicationViews/Countries.vue';
import Functions from 'src/components/ApplicationViews/Functions.vue';
import MeansOfTelecom from 'src/components/ApplicationViews/MeansOfTelecom.vue';
import RolesOffice from 'src/components/ApplicationViews/RolesOffice.vue';
import Roles from 'src/components/ApplicationViews/Roles.vue';
import CustomLists from 'src/components/ApplicationViews/CustomLists.vue';
import CustomListDetails from 'src/components/ApplicationViews/CustomListDetails.vue';
// Annuaire User Notifications
import UserNotifications from 'src/components/ApplicationViews/UserNotifications.vue';

import ParentRouteLayout from '@/components/Dashboard/Layout/ParentRouteLayout.vue';

import NotFound from '../components/GeneralViews/NotFoundPage.vue';
import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue';

const coreDataMenu = {
  path: 'data/',
  redirect: 'data/countries',
  component: ParentRouteLayout,
  children: [
    {
      path: 'addressTypes',
      name: 'AddressTypes',
      component: AddressTypes,
      permissions: {
        lvl: 1,
      },
    },
    {
      path: 'cantons',
      name: 'Cantons',
      component: Cantons,
      permissions: {
        lvl: 1,
      },
    },
    {
      path: 'countries',
      name: 'Countries',
      component: Countries,
      permissions: {
        lvl: 1,
      },
    },
    {
      path: 'functions',
      name: 'Functions',
      component: Functions,
      permissions: {
        lvl: 1,
      },
    },
    {
      path: 'meansOfTelecom',
      name: 'MeansOfTelecom',
      component: MeansOfTelecom,
      permissions: {
        lvl: 1,
      },
    },
    {
      path: 'roles',
      name: 'Roles',
      component: Roles,
      permissions: {
        lvl: 1,
      },
    },
    {
      path: 'rolesOffice',
      name: 'RolesOffice',
      component: RolesOffice,
      permissions: {
        lvl: 1,
      },
    },
    {
      path: 'profiles',
      name: 'Profiles',
      component: Profiles,
      permissions: {
        lvl: 1,
      },
    },
  ],
};

// Applictation routes declaration
const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        permissions: {
          lvl: 1,
        },
      },
      {
        path: 'people',
        name: 'People',
        component: People,
        permissions: {
          lvl: 1,
        },
      },
      {
        path: 'people/:id',
        name: 'PersonDetails',
        component: PersonDetails,
        permissions: {
          lvl: 1,
        },
      },
      {
        path: 'institutions',
        name: 'Institutions',
        component: Institutions,
        permissions: {
          lvl: 1,
        },
      },
      {
        path: 'institutions/:id',
        name: 'InstitutionDetails',
        component: InstitutionDetails,
        permissions: {
          lvl: 1,
        },
      },
      {
        path: 'committees',
        name: 'Committees',
        component: Committees,
      },
      {
        path: 'committees/:id',
        name: 'CommitteeDetails',
        component: CommitteeDetails,
      },
      {
        path: 'customLists',
        name: 'CustomLists',
        component: CustomLists,
        permissions: {
          lvl: 1,
        },
      },
      {
        path: 'customLists/:id',
        name: 'CustomListDetails',
        component: CustomListDetails,
        permissions: {
          lvl: 1,
        },
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets,
        permissions: {
          lvl: 1,
        },
      },
      {
        path: 'userNotifications',
        name: 'UserNotifications',
        component: UserNotifications,
        permissions: {
          lvl: 2,
        },
      },
      coreDataMenu,
    ],
  },
  { path: '*', component: NotFound },
];

export default routes;
